import React, { useState, useEffect } from "react";
import styles from "./styles/ProfileSelect.module.css";
import { useHistory, useLocation } from "react-router-dom";
import customFetch from "../apicall/api";

export default function ProfileSelect() {
  const [profiles, setProfiles] = useState([]);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const history = useHistory();
  const location = useLocation();
  const { api_token, effective_designation_id } = location.state || {};
  const final_api_token = api_token || localStorage.getItem("api_token");

  useEffect(() => {
    async function fetchProfiles() {
      setLoading(true);
      setError("");
      try {
        const params = new URLSearchParams({
          effective_designation_id: effective_designation_id
        });

        // const response = await fetch(`http://localhost:5000/bulk-file-upload/upload-configs?${params.toString()}`, {
        //   method: "GET",
        //   headers: {"api-token": final_api_token },
        // });

        const response = await customFetch(
          `${process.env.REACT_APP_URL}/bulk-file-upload/upload-configs?${params.toString()}`,
          { method: "GET",
            headers: {"api-token": final_api_token }
          }
        );
        const data = await response.json();
        if (data.file_types) {
          setProfiles(data.file_types);
        } else {
          setError("No profiles found.");
        }
      } catch (err) {
        setError("Failed to fetch profiles.");
      }
      setLoading(false);
    }
    fetchProfiles();
  }, []);

  const handleProfileClick = (profile) => {
    history.push({
      pathname: "/bulk-file-upload/profile",
      state: { profile_key: profile.profile_key, profile_name: profile.profile_name, effective_designation_id: effective_designation_id }
    });
  };

  return (
    <div className={styles.container}>
      <h2 className={styles.heading}>Select Profile for Bulk Upload</h2>
      {loading ? (
        <div className={styles.loading}>Loading profiles...</div>
      ) : error ? (
        <div className={styles.error}>{error}</div>
      ) : (
        <div className={styles.profilesGrid}>
          {profiles.map((profile) => (
            <div
              key={profile.profile_key}
              className={`${styles.profileCard} ${
                selectedProfile === profile.profile_key ? styles.selected : ""
              }`}
              onClick={() => handleProfileClick(profile)}
              tabIndex={0}
              role="button"
              aria-pressed={selectedProfile === profile.profile_key}
            >
              <div className={styles.icon}>📁</div>
              <div className={styles.profileInfo}>
                <div className={styles.profileName}>{profile.profile_name}</div>
                <div className={styles.profileDesc}>
                  {profile.is_active ? "Active" : "Inactive"}
                </div>
              </div>
              {selectedProfile === profile.profile_key && (
                <div className={styles.checkmark}>✔</div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
